import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FileInfo} from '../../types/file/file-info';
import {FileUpload} from 'primeng/fileupload';
import {ExtFileInfo} from '../../types/file/ext-file-info';
import * as FileSaver from 'file-saver';
import {FileUtilsService} from '../../services/common/file/file-utils.service';
import {FileRestService} from '../../services/common/file/file-rest.service';
import {FileType} from '../../types/file/file-type';
import * as _ from 'lodash';
import {GlobalMessagesService} from '../../services/messages/global.messages.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'wsd-add-files',
  templateUrl: './add-files.component.html',
  styleUrls: ['./add-files.component.css']
})
export class AddFilesComponent {

  @Input()
  fileType: FileType;

  @Input()
  fileName: string;

  @Input()
  files: ExtFileInfo[] = [];

  @Input()
  editable: boolean = true;

  @Input()
  multiple: boolean = true;

  @Input()
  accept: string;

  @Input()
  hideUpload: boolean;

  @ViewChild('fileUpload')
  fileUpload: FileUpload;

  @Output()
  uploaded = new EventEmitter<any>();

  maxFiles: number = 5;

  FILE_SIZE_LIMIT: number = 10;

  constructor(private fileUtils: FileUtilsService,
              private translate: TranslateService,
              private message: GlobalMessagesService,
              private fileRestService: FileRestService) {
  }

  onSelect(event) {
    let extFile;

    // @ts-ignore
    const redundantFile = _.find(event.files, file => _.some(this.files, {'fileName': file.name}));
    if (redundantFile) {
      this.message.showErrorMessage(
        this.translate.instant('WS_DIRECTORY.ORG_MODIFY.REPORTING.SAME_NAMES',
          // @ts-ignore
          {fileName: redundantFile.name}
        )
      );
    } else {
      for (const file of event.files) {
        extFile = new ExtFileInfo(null, file.name, this.fileType, null, file, null);
        const fileSize = extFile.file.size / 1024 / 1024;
        if (fileSize > this.FILE_SIZE_LIMIT) {
          this.message.showErrorMessage(
            this.translate.instant('WS_DIRECTORY.ORG_MODIFY.REPORTING.MAX_SIZE_PROBLEM'));
          this.fileUpload.clear();
          return;
        }
        this.files.unshift(extFile);
        this.uploaded.emit(extFile);
      }
    }

    this.fileUpload.clear();
  }

  removeArea(file: FileInfo) {
    for (let i = 0; i < this.files.length; i++) {
      if (this.files[i] === file) {
        this.files.splice(i, 1);
        break;
      }
    }
  }

  filteredFiles(): ExtFileInfo[] {
    return this.files
      .filter(Boolean)
      .filter(item => item.type === this.fileType);
  }

  downloadFile(response: any) {
    FileSaver.saveAs(response.body, this.fileUtils.extractFileName(response));
  }

  downloadSelectedFile(extFileInfo: ExtFileInfo) {
    if (extFileInfo.id) {
      this.fileRestService.getFile(extFileInfo.id)
        .subscribe(
          (response: any) => this.downloadFile(response),
          (error: any) => this.handleDownloadError(error)
        );
    } else {
      FileSaver.saveAs(extFileInfo.file, extFileInfo.fileName);
    }

  }

  fileTypeValidation(event) {

    for (const file of event.files) {
      const fileExtension = file.name.split('.').pop();
        if (!this.accept.includes(file.type) && !this.accept.includes(fileExtension)) {
          this.message.showErrorMessage(
            this.translate.instant('WS_DIRECTORY.ORG_MODIFY.REPORTING.INVALID_FORMAT'));
          this.fileUpload.clear();
          return;
        }
    }

  }

  private handleDownloadError(rsp: any) {
  }
}
